import { call, fork, put, takeEvery } from "redux-saga/effects";
import { GET_GPS_PLOT_DATA, GPS_PLOT_API_FAIL } from "./actionTypes";
import { gpsPlotApiSuccess, gpsPlotApiFail } from "./actions";
import { gps_plot_api } from "helpers/backend_helper";

function* fetchGpsPlotData({ payload: { sid } }) {
    try {
        const response = yield call(gps_plot_api, { sid, id: 1 });
        yield put(gpsPlotApiSuccess(response));
    } catch (error) {
        yield put(gpsPlotApiFail(error));
    }
}

function* gpsPlotSaga() {
    yield takeEvery(GET_GPS_PLOT_DATA, fetchGpsPlotData);
}

export default gpsPlotSaga;
